import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="SHOUTENGAI no ana Zuma Tachi parte 3"
      portada="https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-1.jpg"
  paginas={[
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-2.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-3.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-4.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-5.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-6.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-7.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-8.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-9.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-10.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-11.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-12.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-13.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-14.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-15.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-16.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-17.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-18.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-19.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-20.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-21.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-22.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-23.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-24.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-25.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-26.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-27.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-28.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-29.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-30.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-31.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-32.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-33.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-34.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-35.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-36.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-37.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-38.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-39.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-40.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-41.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-42.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-43.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-44.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-45.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-46.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-47.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-48.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-49.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-50.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-51.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-52.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-53.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-54.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-55.jpg",
  "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-56.jpg"
]}


      sugeridos={[]}


      info={{
        grupo: "shoot the moon",
    tipo: "	doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Armpit Licking", "Big Ass", "Big Breasts", "Blowjob", "Condom", "Dark Skin", "Digital Fingering", "Gyaru-oh", "Milf", "Multi-work Series", "Nakadashi", "Netorare", "Sole Female", "Stockings"],  
    artistas: "fuetakishi",


}}

    />
  );
}

export const infoManga = {
  titulo: "SHOUTENGAI no ana Zuma Tachi parte 3",
  portada: "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-1.jpg",
  reverso: "https://fullcomics18.org/img12/shoutengai-no-ana-zuma-tachi3-16.jpg",
      fecha:"2026-05-10", // 👈 MOVER AQUÍ

  info: {
    grupo: "shoot the moon",
    tipo: "	doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Armpit Licking", "Big Ass", "Big Breasts", "Blowjob", "Condom", "Dark Skin", "Digital Fingering", "Gyaru-oh", "Milf", "Multi-work Series", "Nakadashi", "Netorare", "Sole Female", "Stockings"],

  artistas: "fuetakishi",
},
  

};
